import { Component, OnInit } from '@angular/core';
import { SearchTableViewModel } from '../../../view-models/search-table.view-model';
import { SearchTableStateEnum } from '../../../enums/search-table-state.enum';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
  standalone: false,
})
export class ClientListComponent implements OnInit {
  public searchTableViewModel = new SearchTableViewModel<{
    email: string,
    role: string,
    phone: string,
    name: string,
    leadScore: string,
    company: string,
  }>();

  constructor() {
  }

  ngOnInit(): void {
    this.searchTableViewModel.columns = [
      {
        text: 'Name',
        keyname: 'name',
      },
      {
        text: 'Role',
        keyname: 'role',
      },
      {
        text: 'Email',
        keyname: 'email',
      },
      {
        text: 'Phone',
        keyname: 'phone',
      },
      {
        text: 'Lead score',
        keyname: 'leadScore',
      },
      {
        text: 'Company',
        keyname: 'company',
      },
    ];

    this.searchTableViewModel.rows = [
      {
        email: 'diana.smiley@company.com',
        role: 'Designer',
        phone: '514-577-8120',
        name: 'Dianna Smiley',
        leadScore: '1/10',
        company: 'Twitter',
      },
      {
        email: 'ab.hadley@company.com',
        role: 'Developer',
        phone: '514-771-4122',
        name: 'Ab Hadley',
        leadScore: '8/10',
        company: 'Google',
      },
      {
        email: 'adolfo.hess@company.com',
        role: 'Owner',
        phone: '514-771-4122',
        name: 'Adolfo Hess',
        leadScore: '7/10',
        company: 'Google',
      },
      {
        email: 'daniela.dewitt@company.com',
        role: 'Designer',
        phone: '514-225-6659',
        name: 'Daniela Dewitt',
        leadScore: '2/10',
        company: 'Twitch',
      },
      {
        email: 'miyah.myles@company.com',
        role: 'founder',
        phone: '514-165-8435',
        name: 'Miyah Myles',
        leadScore: '8/10',
        company: 'Facebook',
      },
    ];

    this.searchTableViewModel.onUpdate.subscribe(searchTableViewModel => {
      searchTableViewModel.state = SearchTableStateEnum.Loading;

      setTimeout(() => {
        searchTableViewModel.state = SearchTableStateEnum.Loaded;
        searchTableViewModel.numberOfTotalResults = 75;
        searchTableViewModel.numberOfResultsPerPage = 10;
      }, 1500);

    });
  }

}
